import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler, ResetSliceState } from "../../../app/SliceUtils";

export const getHeadTypes = createAsyncThunk(
    '/api/typeManagement/head',
    (_, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/typeManagement/head`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const getActivityTypes = createAsyncThunk(
    '/api/typeManagement/activity',
    (_, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/typeManagement/activity`,
            contentType: 'application/x-www-form-urlencoded'
        }, rejectWithValue)
);

export const postHeadType = createAsyncThunk(
    '/api/typeManagement/head/post',
    (newHeadType, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/typeManagement/head`,
            method: 'POST',
            body: newHeadType
        }, rejectWithValue)
);

export const postActivityType = createAsyncThunk(
    '/api/typeManagement/activity/post',
    (newActivityType, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/typeManagement/activity`,
            method: 'POST',
            body: newActivityType
        }, rejectWithValue)
);

export const putHeadType = createAsyncThunk(
    '/api/typeManagement/head/put',
    (updatedHeadType, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/typeManagement/head`,
            method: 'PUT',
            body: updatedHeadType
        }, rejectWithValue)
);

export const putActivityType = createAsyncThunk(
    '/api/typeManagement/activity/put',
    (updatedActivityType, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/typeManagement/activity`,
            method: 'PUT',
            body: updatedActivityType
        }, rejectWithValue)
);

export const deleteHeadType = createAsyncThunk(
    '/api/typeManagement/head/delete',
    (headTypeId, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/typeManagement/head/${headTypeId}`,
            method: 'DELETE'
        }, rejectWithValue)
);

export const deleteActivityType = createAsyncThunk(
    '/api/typeManagement/activity/delete',
    (activityTypeId, { rejectWithValue }) =>
        ApiFetch({
            endpoint: `api/typeManagement/activity/${activityTypeId}`,
            method: 'DELETE'
        }, rejectWithValue)
);

export const typeManagementSlice = createSlice({
    name: 'typeManagement',
    initialState: {
        headTypes: { data: null, status: null },
        activityTypes: { data: null, status: null },
        headTypePost: { data: null, status: null },
        activityTypePost: { data: null, status: null },
        headTypePut: { data: null, status: null },
        activityTypePut: { data: null, status: null },
        headTypeDelete: { data: null, status: null },
        activityTypeDelete: { data: null, status: null },

        selectedType: null,
        showFailed: false,
    },
    reducers: {
        selectType: (state, action) => {
            state.selectedType = action.payload;
        },
        resetTypeStatus: (state) => {
            ResetSliceState(state);
        },
        setFailedType: (state, action) => {
            state.showFailed = action.payload;
        },
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, getHeadTypes, 'headTypes');
        CreateAsyncStatusHandler(builder, getActivityTypes, 'activityTypes');
        CreateAsyncStatusHandler(builder, postHeadType, 'headTypePost');
        CreateAsyncStatusHandler(builder, postActivityType, 'activityTypePost');
        CreateAsyncStatusHandler(builder, putHeadType, 'headTypePut');
        CreateAsyncStatusHandler(builder, putActivityType, 'activityTypePut');
        CreateAsyncStatusHandler(builder, deleteHeadType, 'headTypeDelete');
        CreateAsyncStatusHandler(builder, deleteActivityType, 'activityTypeDelete');
    },
});

export const {
    resetTypeStatus,
    selectType,
    setFailedType
} = typeManagementSlice.actions;

export default typeManagementSlice.reducer;